import React from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import "./ProdList.scss";
import { useEffect, useState } from 'react';
import { Tab, Spinner, Nav } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../admin/api/api";
import { useSearchParams } from "react-router-dom";
import { image_base_url } from "../admin/api/api";


function ProdList() {
  const navigate = useNavigate();
  const location = useLocation();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [key, setKey] = useState("filter");

  const [searchParams] = useSearchParams();
  const subCategoryId = searchParams.get("subcategory");
  const categoryId = searchParams.get("category");

  const [sort, setSort] = useState("");

// Fetch products when filter changes
  const [filters, setFilters] = useState({
  minPrice: "",
  maxPrice: "",
  discount: "",
  size: "",
  color: "",
  newArrival: false
});

useEffect(() => {

  loadProducts();

}, [filters, sort, categoryId, subCategoryId]);

const loadProducts = async () => {

  const params = {
    categoryId: categoryId,
    subCategoryId: subCategoryId,
    minPrice: filters.minPrice,
    maxPrice: filters.maxPrice,
    discount: filters.discount,
    size: filters.size,
    color: filters.color,
    newArrival: filters.newArrival,
    sort: sort
  };

  const res = await api.get("/Products/filter", { params });

  setProducts(res.data);

};


  const clearFilters = () => {

  setFilters({
    minPrice: "",
    maxPrice: "",
    discount: "",
    size: "",
    color: "",
    newArrival: false
  });

};
  
  return (
    <>
    <Container fluid className="product-page" style={{paddingBottom : "10px"}}></Container>
    <Container fluid className="product-page ">
      <Row>

        {/* ========== FILTER SECTION (LEFT) ========== */}
        <Col md={2} className="filter-section d-none d-md-block" style={{marginTop : "17px"}}>

  <div className="filter-header">
    <h5>Filters</h5>
    <span className="clear-filter" onClick={clearFilters}>
     Clear All
    </span>
  </div>

  {/* Price */}
  <div className="filter-block">
    <h6 className="filter-heading">Price</h6>
    <Form.Range 
    min={0}
    max={2000}
   onChange={(e) =>
    setFilters({
      ...filters,
      maxPrice: e.target.value
    })
  }
    />
    <div className="price-range">
      <span>₹100</span>
      <span>₹2000</span>
    </div>
  </div>

  {/* Discount */}
  <div className="filter-block">
    <h6 className="filter-heading">Discount</h6>
    <Form.Check type="checkbox" label="20% or more" onChange={() => setFilters({ ...filters, discount: 20 }) } />
    <Form.Check type="checkbox" label="30% or more" onChange={() => setFilters({ ...filters, discount: 30 }) } />
  </div>

  {/* Size */}
  <div className="filter-block">
    <h6 className="filter-heading">Size</h6>
    <div className="size-box">
      <Button variant="outline-secondary" size="sm" onClick={() => setFilters({ ...filters, size: "S" }) }>S</Button>
      <Button variant="outline-secondary" size="sm" onClick={() => setFilters({ ...filters, size: "M" }) }>M</Button>
      <Button variant="outline-secondary" size="sm" onClick={() => setFilters({ ...filters, size: "L" }) }>L</Button>
      <Button variant="outline-secondary" size="sm" onClick={() => setFilters({ ...filters, size: "XL" }) }>XL</Button>
    </div>
  </div>

  {/* Colors */}
  <div className="filter-block">
    <h6 className="filter-heading">Colors</h6>
    <div className="color-box">
      <span className="color red" onClick={() => setFilters({ ...filters, color: "Red" }) }></span>
      <span className="color black" onClick={() => setFilters({ ...filters, color: "Black" }) }></span>
      <span className="color blue" onClick={() => setFilters({ ...filters, color: "Blue" }) }></span>
      <span className="color pink" onClick={() => setFilters({ ...filters, color: "Pink" }) }></span>
    </div>
  </div>

  {/* New Arrival */}
  <div className="filter-block">
    <h6 className="filter-heading">New Arrivals</h6>
    <Form.Check type="switch" label="Show New Products"
      onChange={(e) => setFilters({ ...filters, newArrival: e.target.checked }) }/>
  </div>

</Col>

{/* ========== MOBILE FILTER BAR ========== */}
<div className="mobile-filter-bar d-md-none">

  {/* Scrollable Tab Buttons Only */}
  <div className="filter-scroll">
    <Nav
      variant="tabs"
      activeKey={key}
      onSelect={(k) => setKey(k)}
      className="flex-nowrap"
    >
      <Nav.Item>
        <Nav.Link eventKey="filter">Filter By :</Nav.Link>
      </Nav.Item>

      <Nav.Item>
        <Nav.Link eventKey="price">Price</Nav.Link>
      </Nav.Item>

      <Nav.Item>
        <Nav.Link eventKey="discount">Discount</Nav.Link>
      </Nav.Item>

      <Nav.Item>
        <Nav.Link eventKey="size">Size</Nav.Link>
      </Nav.Item>

      <Nav.Item>
        <Nav.Link eventKey="color">Color</Nav.Link>
      </Nav.Item>

      <Nav.Item>
        <Nav.Link eventKey="newarr">New Arrivals</Nav.Link>
      </Nav.Item>

    </Nav>
  </div>

  {/* Tab Content (Full Width) */}
  <Tab.Content className="mobile-tab-content">
    <Tab.Pane eventKey="filter" active={key === "filter"}>
        <span className="clear-filter" onClick={clearFilters}> Clear All </span>
    </Tab.Pane>

    <Tab.Pane eventKey="price" active={key === "price"}>
      
      <Form.Range 
       min={0}
       max={2000}
       onChange={(e) =>
       setFilters({
      ...filters,
      maxPrice: e.target.value
     })
   }
    />
    <div className="price-range">
      <span>₹100</span>
      <span>₹2000</span>
    </div>

    </Tab.Pane>

    <Tab.Pane eventKey="discount" active={key === "discount"}>
      
       <Form.Check type="checkbox" label="20% or more" onChange={() => setFilters({ ...filters, discount: 20 }) } />
       <Form.Check type="checkbox" label="30% or more" onChange={() => setFilters({ ...filters, discount: 30 }) } />

    </Tab.Pane>

    <Tab.Pane eventKey="size" active={key === "size"}>
      
      <div className="size-box">
     <Button variant="outline-secondary" size="sm" onClick={() => setFilters({ ...filters, size: "S" }) }>S</Button>
      <Button variant="outline-secondary" size="sm" onClick={() => setFilters({ ...filters, size: "M" }) }>M</Button>
      <Button variant="outline-secondary" size="sm" onClick={() => setFilters({ ...filters, size: "L" }) }>L</Button>
      <Button variant="outline-secondary" size="sm" onClick={() => setFilters({ ...filters, size: "XL" }) }>XL</Button>
    </div>

    </Tab.Pane>

    <Tab.Pane eventKey="color" active={key === "color"}>
      
      <div className="color-box">
       <span className="color red" onClick={() => setFilters({ ...filters, color: "Red" }) }></span>
      <span className="color black" onClick={() => setFilters({ ...filters, color: "Black" }) }></span>
      <span className="color blue" onClick={() => setFilters({ ...filters, color: "Blue" }) }></span>
      <span className="color pink" onClick={() => setFilters({ ...filters, color: "Pink" }) }></span>
    </div>

    </Tab.Pane>

    <Tab.Pane eventKey="newarr" active={key === "newarr"}>
      
       <Form.Check type="switch" label="Show New Products"
      onChange={(e) => setFilters({ ...filters, newArrival: e.target.checked }) }/>

    </Tab.Pane>

  </Tab.Content>

</div>


        {/* ========== PRODUCT LIST SECTION (RIGHT) ========== */}
        
    <Col md={10} className="pt-3">
            
    <Row className="product-toolbar align-items-center">

  <Col md={6} xs={6}>
    <div className="product-count">
      <span style={{color : "red"}}>{products.length}</span> Items
    </div>
  </Col>

  <Col md={6} xs={6} className="text-end">

    <Form.Select
      className="sort-select"
      onChange={(e)=>setSort(e.target.value)}
    >
      <option value="">Sort By</option>
      <option value="price_low">Price Low → High</option>
      <option value="price_high">Price High → Low</option>
      <option value="newest">Newest</option>
    </Form.Select>

  </Col>

</Row>
            
            <Row>

              {/* Loading */}
              {loading && (
                <div className="text-center mt-5">
                  <Spinner animation="border" />
                </div>
              )}

              {/* No Products */}
              {!loading && products.length === 0 && (
                <div className="text-center mt-5">
                  <h5>No Products Found</h5>
                </div>
              )}

              {/* Product Cards */}
              {!loading &&
                products.map((item) => (
                  <Col md={3} xs={6} key={item.productId} className="mb-4">

                    <Card
                      className="product-card h-100 shadow-sm"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(`/product/${item.productId}`)
                      }
                    >
                      {/* Image */}
                      <div className="product-image-wrapper position-relative">

                        <Card.Img
                          variant="top"
                          src={
                            item.mainImageUrl
                              ? `${image_base_url}${item.mainImageUrl}`
                              : "/images/no-image.png"
                          }
                          className="product-image"
                        />

                        {/* Discount Badge (optional) */}
                        {item.discountPercent && (
                          <span className="discount-badge01 position-absolute bg-danger text-white px-2 py-1">
                            {item.discountPercent}% OFF
                          </span>
                        )}

                      </div>

                      {/* Body */}
                      <Card.Body className="d-flex flex-column">

                        <Card.Title className="product-title">
                          {item.productName}
                        </Card.Title>

                        <p className="product-desc">
                          {item.description}
                        </p>

                        <div className="price-section01 mt-auto">
                         <span className="fw-bold new-price">
                           ₹{item.price}
                         </span>

                        {item.mrp && (
                          <span className="old-price text-muted ms-2 text-decoration-line-through">
                            ₹{item.mrp}
                          </span>
                         )}
                        </div>

                      </Card.Body>
                    </Card>

                  </Col>
                ))}

            </Row>
          </Col>

      </Row>
    </Container>
    </>
  );
}

export default ProdList;